export default "/images/vendor/jquery-ui/themes/base/ui-icons_444444_256x240.png?2bf13b17d09412f118b0d2191a04af9d";